import { useRef, useState } from 'react'
import { cn } from '@/lib/utils'
import { ChevronLeftIcon, ChevronRightIcon } from './icons'
import { ProfitCard, type ProfitItem } from './ProfitCard'

const PROFIT_ITEMS: ProfitItem[] = [
	{
		id: 'becy',
		symbol: 'BECY',
		amount: '452 687',
		decimals: '.98',
		percent: 72,
		ringColor: 'hsl(var(--info))',
		badgeBgClassName: 'bg-[hsl(var(--info)/0.08)]',
		badgeTextClassName: 'text-info',
		active: true,
	},
	{
		id: 'eth',
		symbol: 'ETH',
		amount: '0',
		decimals: '.0',
		percent: 0,
		ringColor: 'hsl(var(--purple))',
		badgeBgClassName: 'bg-[hsl(var(--purple)/0.08)]',
		badgeTextClassName: 'text-purple',
	},
	{
		id: 'usdt',
		symbol: 'USDT',
		amount: '0',
		decimals: '.0',
		percent: 0,
		ringColor: 'hsl(var(--success))',
		badgeBgClassName: 'bg-[hsl(var(--success)/0.08)]',
		badgeTextClassName: 'text-success',
	},
	{
		id: 'becy-2',
		symbol: 'BECY',
		amount: '452 687',
		decimals: '.98',
		percent: 0,
		ringColor: 'hsl(var(--info))',
		badgeBgClassName: 'bg-[hsl(var(--info)/0.08)]',
		badgeTextClassName: 'text-info',
	},
]

export function ProfitCarousel() {
	const scrollRef = useRef<HTMLDivElement>(null)
	const [activeIndex, setActiveIndex] = useState(0)

	const scrollByCard = (direction: 1 | -1) => {
		const el = scrollRef.current
		if (!el) return
		el.scrollBy({ left: direction * 320, behavior: 'smooth' })
	}

	const handleScroll = () => {
		const el = scrollRef.current
		if (!el) return
		const index = Math.round((el.scrollLeft / (el.scrollWidth - el.clientWidth || 1)) * (PROFIT_ITEMS.length - 1))
		setActiveIndex(Number.isFinite(index) ? index : 0)
	}

	return (
		<div className='flex flex-col gap-4'>
			<div className='flex items-center justify-between'>
				<h2 className='flex items-center gap-3 text-2xl font-semibold tracking-[-0.12px] text-foreground'>Profit</h2>
				<div className='flex items-center gap-1'>
					<button
						type='button'
						onClick={() => scrollByCard(-1)}
						className='flex h-11 w-11 items-center justify-center rounded-xl border border-border bg-card text-foreground'
						aria-label='Previous'
					>
						<ChevronLeftIcon className='h-[22px] w-[22px]' />
					</button>
					<button
						type='button'
						onClick={() => scrollByCard(1)}
						className='flex h-11 w-11 items-center justify-center rounded-xl border border-border bg-card text-foreground'
						aria-label='Next'
					>
						<ChevronRightIcon className='h-[22px] w-[22px]' />
					</button>
				</div>
			</div>

			<div ref={scrollRef} onScroll={handleScroll} className='flex snap-x snap-mandatory gap-4 overflow-x-auto pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'>
				{PROFIT_ITEMS.map((item) => (
					<ProfitCard key={item.id} item={item} />
				))}
			</div>

			<div className='flex items-center justify-center gap-1'>
				{PROFIT_ITEMS.map((item, i) => (
					<span key={item.id} className={cn('h-1.5 rounded-full transition-all', i === activeIndex ? 'w-3 bg-primary' : 'w-1.5 bg-border')} />
				))}
			</div>
		</div>
	)
}
